

























import Vue from 'vue'
import {ReturnDataViewModel} from "@/models/ReturnDataViewModel";
import {UserViewModel} from "@/models/UserViewModel";
import MunicipalityForm from "@/components/admin/MunicipalityForm.vue";
import {MunicipalityViewModel} from "@/models/MunicipalityViewModel";

export default Vue.extend( {
  name: "MunicipalityNew",
  components: {MunicipalityForm},
  data(): {
    itemId: number
    municipality: MunicipalityViewModel
    formSaving: boolean
  }{
    return {
      itemId: 0 ,
      municipality: {} as MunicipalityViewModel ,
      formSaving: false
    }
  },
  computed: {
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    },
  },
  beforeCreate() {
    setTimeout( async () => {
      if ( this.$store.state.loggedInUser == null ) {
        //make one attempt to get the current user info
        try {
          let result = await this.axios.get('Users/GetUserFromToken');
          if ( result.status === 200 ) {
            await this.$store.dispatch('updateUser', result.data);
          }
        } catch ( err ) {
          if ( err.response.status === 400  ) {
            await this.$router.push('/Login');
          }
        }
      }
    } , 250 );
  },
  methods: {
    async createMunicipality() {
      try {

        this.formSaving = true;

        const result = await this.axios.post( '/Lookups/PostMunicipality' , this.municipality , {headers: { "Content-Type": "application/json" } } )
        if ( result.status === 200 ) {
          const data = result.data as unknown as ReturnDataViewModel;
          let returnedId = data.idReturned.toString();
          await this.$router.push( { name: "municipality-list" } )
        }
      }
      catch ( err ) {
        if ( err.response.status === 400 || err.response.status === 403 || err.response.status === 404 || err.response.status === 409 ) {
          console.log( err.response.data.message )
        }
      }
      finally {
        this.formSaving = false;
      }
    }
  },
} )

